import { render, staticRenderFns } from "./InventoryStateConfig.vue?vue&type=template&id=b8a210b6"
import script from "./InventoryStateConfig.vue?vue&type=script&lang=js"
export * from "./InventoryStateConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports